/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ApplicationContext from '../../context/ApplicationContext';
import InsuranceHeader from './InsuranceHeader';
import ChoiceSection from '../../components/ChoiceSection';
import { dataService } from '../../services/data.service';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { insuranceLanguageContent } from './InsuranceLanguageContent';

function InsuranceDocuments() {
    const { handlePage, sessionData, setInsuranceIndex, insurancePreference, idCardData, selectedLanguage, insurances } = useContext(ApplicationContext);
    const [firstQuestionChoice, setFirstQuestionChoice] = useState('');
    const [secondQuestionChoice, setSecondQuestionChoice] = useState('');
    const [thirdQuestionChoice, setThirdQuestionChoice] = useState('');
    const [loading, setLoading] = useState(false);
    const [noClicked, setNoClicked] = useState(false);

    const handleBackNavigation = () => {
        handlePage((idCardData.card_issuer !== '' && idCardData.is_idenity_present === true) ? 'card_details' : 'identity', '', '', sessionData['review'] === 'previous' ? 'previous' : '');
    }
    const handleFirstQuestionSubmission = (choice) => {
        if(choice === 'Yes') {
            setSecondQuestionChoice('');
            setThirdQuestionChoice('');
        } else {
            setNoClicked(true);
            const payload = {
                "is_insurance_exists": "No",
                "is_multiple_insurance_exists": "NA",
                "is_policy_holder": "NA"
            }
            dataService.updateInsurancePreference(sessionStorage.getItem('session'), payload).then((res) => {
                setNoClicked(false);
                // I need to add a condition here for when opted out
                if(sessionData['review'] === 'previous' || sessionData?.patient_details?.is_opt_out) {
                    handlePage('review')
                } else {
                    handlePage(sessionData.documents_count > 0 ? 'documents' : 'review', '', '', sessionData['review'] === 'previous' ? 'previous' : '',null, null,sessionData.document_session);
                }
            })
        }
    }

    const handleNextNavigation = () => {
        setLoading(true);
        const payload = {
            "is_insurance_exists": firstQuestionChoice,
            "is_multiple_insurance_exists": secondQuestionChoice,
            "is_policy_holder": thirdQuestionChoice
        }
        dataService.updateInsurancePreference(sessionStorage.getItem('session'), payload).then((res) => {
            setLoading(true);
            if(insurancePreference.is_insurance_exists === 'NA' && insurances.length > 0) {
                setInsuranceIndex(0)
                handlePage(`upload_insurance_choice`, '', 0, sessionData['review'] === 'previous' ? 'previous' : '');
            } else {
                if(firstQuestionChoice === 'Yes') {
                    setInsuranceIndex(0)
                    handlePage(`upload_insurance_choice`, '', 0, sessionData['review'] === 'previous' ? 'previous' : '');
                } else {
                    // I need to add a condition here for when opted out
                    if(sessionData['review'] === 'previous' || sessionData?.patient_details?.is_opt_out) {
                        handlePage('review')
                    } else {
                        handlePage(sessionData.documents_count > 0 ? 'documents' : 'review', '', '', sessionData['review'] === 'previous' ? 'previous' : '',null, null, sessionData.document_session);
                    }
                }
            }
        })
    }

    

    useEffect(() => {
        if(insurances.length > 0 && insurancePreference.is_insurance_exists === "NA") {
            setFirstQuestionChoice(insurances.length > 0 ? 'Yes' : '');
            setSecondQuestionChoice(insurances.length > 1 ? 'Yes' : 'No');
            setThirdQuestionChoice(insurances[0].policy_holder_name === (sessionData.first_name + ' ' + sessionData.last_name)  ? 'yes' : 'No');
        } else {
            setFirstQuestionChoice(insurancePreference.is_insurance_exists === 'NA' ? '' : insurancePreference.is_insurance_exists);
            setSecondQuestionChoice(insurancePreference.is_multiple_insurance_exists === 'NA' ? '' : insurancePreference.is_multiple_insurance_exists);
            setThirdQuestionChoice(insurancePreference.is_policy_holder === 'NA' ? '' : insurancePreference.is_policy_holder);
        }
    }, [insurancePreference])

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <InsuranceHeader />
                <div className='mt-[18px] pb-[18px]'>
                    <ChoiceSection callback={true} handleNext={handleFirstQuestionSubmission} event="insurance-first" question={insuranceLanguageContent['insurance-question-1'][selectedLanguage]} 
                        selectedChoice={firstQuestionChoice} setSelectedChoice={setFirstQuestionChoice} choice1="Yes" choice2="No" />
                </div>
                {firstQuestionChoice === 'Yes' && 
                <>
                    <div className='py-[18px] border-t border-b border-[#D7D7D7]'>
                        <ChoiceSection callback={false} event="insurance-second" question={insuranceLanguageContent['insurance-question-2'][selectedLanguage]} 
                            selectedChoice={secondQuestionChoice} setSelectedChoice={setSecondQuestionChoice} choice1="Yes" choice2="No" />
                    </div>
                    <div className='py-[18px] border-[#D7D7D7]'>
                        <ChoiceSection callback={false} event="insurance-third" question={insuranceLanguageContent['insurance-question-3'][selectedLanguage]} 
                            selectedChoice={thirdQuestionChoice} setSelectedChoice={setThirdQuestionChoice} choice1="Yes" choice2="No" />
                    </div>
                </>}
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap gap-[12px]'>
                <BackButton disabled={loading || noClicked} handleClick={() => handleBackNavigation()} backType="previous" />
                <NextButton disabled={firstQuestionChoice === '' || (firstQuestionChoice === 'Yes' && (secondQuestionChoice === '' || thirdQuestionChoice === '')) || loading || noClicked} handleClick={() => handleNextNavigation()}  loader={loading} />
            </div>
        </AnimatedPageFade>
    );
}

export default InsuranceDocuments;